import { cn } from "@/lib/utils";
import { Spinner } from "./spinner";

interface FullPageLoadingProps {
  message?: string;
  className?: string;
}

export function FullPageLoading({ message, className }: FullPageLoadingProps) {
  return (
    <div
      className={cn(
        "fixed inset-0 flex items-center justify-center bg-white z-50",
        className
      )}
    >
      <div className="flex flex-col items-center gap-4">
        <Spinner size="xl" />
        {message && (
          <p className="font-inter text-sm text-neutral-600">{message}</p>
        )}
      </div>
    </div>
  );
}
